import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../../spinner'

const CommunityStorySpinner = (props: {
  size: number
}) => {
  if (props.size >= 800) {
    return (
      <div className="community-stories-wrapper">
        <div key="1" className="community-story big"><Spinner visible={true}/></div>
        <div key="2" className="community-story small"><Spinner visible={true}/></div>
        <div key="3" className="community-story small"><Spinner visible={true}/></div>
      </div>
    )
  }
  else {
    return (
      <div className="community-stories-wrapper">
        <div key="1" className="community-story big"><Spinner visible={true}/></div>
      </div>
    )
  }
  
}

CommunityStorySpinner.propTypes = {
  size: PropTypes.number
}

export default CommunityStorySpinner